import Agenda from "../classes/Agenda";
import AgribexForm from "../classes/AgribexForm";
import FlickerEmbedHelper from "../classes/FlickerEmbedHelper";
import HamburgerNav from "../classes/HamburgerNav";
import RefreshMeeting from "../classes/RefreshMeeting";
import SwiperHelper from "../classes/SwiperHelper";
import TagFilter from "../classes/TagFilter";
import ZoomBinar from "../classes/ZoomBinar";

//init application
const initApplication = () => {
  const hamburger = new HamburgerNav({
    navSelector: ".fullNav",
    navOpenBtn: ".hamburgerNav",
    navCloseBtn: ".hamburgerNav",
  });

  hamburger.init();

  const uitgelichtswiper = new SwiperHelper({
    swiperSelector: ".uitgelichtSwiper",
    swiperOptions: {
      loop: true,
      spaceBetween: 8,
      breakpoints: {
        // when window width is >= 320px
        1024: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    },
  });

  uitgelichtswiper.init();

  const impressiesSwiper = new SwiperHelper({
    swiperSelector: ".impressiesSwiper",
    swiperOptions: {
      loop: true,
      spaceBetween: 8,
    },
  });

  impressiesSwiper.init();

  const newsFilter = new TagFilter({
    searchUrl: "",
    inputSelector: ".newsFilter input",
    resultsSelector: ".newsFilter .results",
    tagsHolderSelector: ".newsFilter .tagsHolder",
    clearSelector: ".newsFilter .clear",
    itemHolderSelector: "newsHolder",
    listSettings: {
      valueNames: ["title", { data: ["category", "author", "date"] }],
    },
    minCharacters: 2,
  });

  newsFilter.init();

  //confirm mail
  const confirmForm = new AgribexForm({
    formSelector: ".bevestigingEvent .aanvraagForm",
    teamMembersHolderSelector: ".teamMembersHolder",
    removeBtnSelector: ".removeTeamMember",
    invitedInputsHolderSelector: ".invitedInputsHolder",
    addTeamOptions: {
      formHolderSelector: ".teamMemberPanel",
      closeBtnSelector: ".closeTeamMemberPanel",
      openBtnSelector: ".openTeamMemberPanel",
      editTeamMemberSelector: ".editTeamMember",
    },
  });

  confirmForm.init();

  //flickr helper
  const flickrHelper = new FlickerEmbedHelper({
    flickrIframeSelector: ".flickrEmbed",
  });

  flickrHelper.init();

  //agenda
  const agenda = new Agenda({
    fetchUrl: "/",
    agendaSelector: ".agenda",
    agendaFilterSelector: ".agendaFilter",
    listSettings: {
      valueNames: ["title", { data: ["category", "author"] }],
    },
    minCharacters: 2,
    agendaTitleSelector: ".agendaHeader h3",
    agendaPrevSelector: ".agendaPrev",
    agendaNextSelector: ".agendaNext",
  });

  agenda.init();

  if (zoomSDKSettings) {
    //zoom binar setup
    const zoomBinar = new ZoomBinar({
      zoomSelector: ".zoomElem",
      meetConfig: {
        signatureUrl: "/api/get-signature",
        ...zoomSDKSettings,
        role: 0, // 1 for host; 0 for attendee
      },
    });

    zoomBinar.init();
  }

  //refresh meeting
  const refreshMeeting = new RefreshMeeting({
    binarWaitingSelector: ".binarWaiting",
    apiUrl: "/api/check-access",
  });

  refreshMeeting.init();
};

export default initApplication;
